module.exports = __webpack_public_path__ + "img/loading.f30ddc0c.gif";